import { Logo, LeftArrow } from "../../assets";
import PartySelect from "./PartySelect";
import { useTranslation } from "react-i18next";

const Header = ({ t, data, selectedParty, partyQueryHandler }) => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const navigateBack = () => {
    let url = "";
    if (language === "de") {
      url =
        "https://www.wort.lu/politik/wahlkampfmodul-chamberwahlen-2023/2575625.html";
    } else if (language === "fr") {
      url =
        "https://www.virgule.lu/luxembourg/tout-ce-quil-faut-savoir-sur-les-elections-legislatives/2583123.html";
    } else if (language === "pt") {
      url =
        "https://www.contacto.lu/luxemburgo/tudo-o-que-precisa-de-saber-sobre-as-eleicoes-legislativas/2727696.html";
    } else if (language === "en") {
      url =
        "https://www.luxtimes.lu/luxembourg/everything-you-need-to-know-about-the-legislative-elections/2727632.html";
    }

    window.parent.location.href = url;
  };

  return (
    <div className="flex flex-col pt-10 md:pt-6 px-0">
      <div className="flex flex-row items-center pb-3 md:min-w-[420px]">
        <div
          className="flex items-center cursor-pointer group"
          onClick={navigateBack}
        >
          <LeftArrow className="mr-2 transition-transform duration-200 transform group-hover:scale-105" />
          <span className="font-medium text-primary uppercase ml-2 md:ml-4 border-b-2 border-transparent group-hover:border-primary transition-border duration-200">
            {t("back")}
          </span>
        </div>
      </div>

      <div className="flex flex-row items-center pb-3 md:min-w-[420px]">
        <Logo />
        <span className="font-medium text-[32px] leading-[38px] ml-4 md:ml-6 ">
          {t("steckbrief")}
        </span>
      </div>
      <PartySelect
        data={data}
        t={t}
        selectedParty={selectedParty}
        partyQueryHandler={partyQueryHandler}
      />
      <div className="h-0.5 bg-black bg-opacity-40 md:hidden mt-4 mb-7"></div>
    </div>
  );
};

export default Header;
